// PopoverPlannerAssignee Component

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Avatar from '../../common/avatar/avatar.jsx'

import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Popover from '../../../common/common/popover/popover.jsx'

class PopoverPlannerAssignee extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      dataDate: new Date()
    }

    this._data = {
      task: null,
      user: null,
      projects: [],
      totalHours: 0,
      container: null,
      target: null,
      userIndex: 0
    }

    this._references = {
      PopoverPlannerAssignee: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onClose: PropTypes.func,
      scheduleType: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      onClose: null,
      scheduleType: ''
    }
  }

  /* Public Functions */
  show (task, user, projects, container, userIndex) {
    this._data.task = task
    this._data.user = user
    this._data.projects = projects
    this._data.totalHours = this._calculateTotalHours(projects)
    this._data.container = container
    this._data.userIndex = userIndex || 0

    this.setState({ active: true, dateDate: new Date() })
  }

  hide = () => {
    this.setState({ active: false, dateDate: new Date() })
    this._data.task = null
    this._data.user = null
    this._data.projects = []
    this._data.container = null
    this._data.target = null
    this._data.userIndex = 0
  }

  /* Private Functions */
  _calculateTotalHours (projects) {
    let totalHours = 0
    projects.forEach(activity => {
      totalHours += activity.noHours
    })

    return totalHours
  }

  /* Handler Functions */

  /* Other Render Functions */
  _renderUserInfo () {
    const { user } = this._data

    if (!user) {
      return null
    }

    const { onClose } = this.props
    return (
      <div className='userinfo'>
        <div className='popover-useritem'>
          {user.checked ? (
            <span className='iconselect checked'>
              <span className='icon checked' />
            </span>
          ) : (
            <span className={`iconselect iconselect_${user.scheduleType}`}>
              <span className='icon' />
            </span>
          )}
          <Avatar imageUrl={user.imageUrl} />
          <span className='popover-title'>{user.displayName}</span>
          <IconButton
            icon='x'
            type='secondary'
            className='action'
            canHover
            onClick={onClose}
          />
        </div>
      </div>
    )
  }

  _renderProjectsInfo () {
    const { projects, task, totalHours } = this._data
    if (!projects || !task) {
      return null
    }

    const { projectId } = task
    const otherProjects = [...projects]
    const currentProjects = _.remove(
      otherProjects,
      project => project.id === projectId
    )
    const currentProjectTitle =
      currentProjects.length > 0 ? currentProjects[0].title : ''
    const currentProjectNoHours = _.sumBy(currentProjects, function (project) {
      return project.noHours
    })

    return (
      <div className='projectinfo'>
        <div className='current-projectinfo'>
          <div className='current-hourinfo'>
            <IntlMessage ident='popover.popover.currentTaskInfo' />
          </div>
          <div className='current-projectitem'>
            {currentProjectTitle !== '' && (
              <div className='titlehour-info'>
                <div className='project'>{currentProjectTitle}</div>
                <div className='activityhour'>{currentProjectNoHours}</div>
              </div>
            )}
          </div>
        </div>
        <div className='other-projectinfo'>
          {otherProjects.length > 0 && (
            <div className='other-hourinfo'>
              <IntlMessage ident='popover.popover.otherTaskInfo' />
            </div>
          )}
          <div className='other-projectitem'>
            {otherProjects.map((project, idx) => (
              <div className='titlehour-info' key={idx}>
                <div className='project'>{project.title}</div>
                <div className='activityhour'>{project.noHours}</div>
              </div>
            ))}
          </div>
        </div>
        <div className='linebreak' />
        <div className='popover-bottom'>
          <div className='totalhours'>{totalHours}</div>
        </div>
      </div>
    )
  }

  _renderContent () {
    return (
      <div className='popover-content'>
        {this._renderUserInfo()}
        {this._renderProjectsInfo()}
      </div>
    )
  }

  /* Render Function */
  render () {
    const { container, target, userIndex } = this._data
    const { active } = this.state
    const top = userIndex * 32

    return (
      <Popover
        placement='bottom'
        container={container || this}
        target={target}
        show={active}
        outerStyle={{ left: '0px', top: `${top}px` }}
        className='popover-plannerassignee'
        onHide={this.hide} // eslint-disable-line react/jsx-handler-names
        arrowClass='popovertip'
      >
        {this._renderContent()}
      </Popover>
    )
  }
}

export default PopoverPlannerAssignee
